import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=0795b25a&scoped=true&"
import script from "./TeamMemberCard.vue?vue&type=script&lang=js&"
export * from "./TeamMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberCard.vue?vue&type=style&index=0&id=0795b25a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795b25a",
  null
  
)

export default component.exports